/**
 * The 'DISABLE_TRAVELLING' action.
 * @type {'ACTION_DISABLE_TRAVELLING'}
 * @constant
 */
const DISABLE_TRAVELLING = 'ACTION_DISABLE_TRAVELLING';

/**
 * The 'ENABLE_TRAVELLING' action.
 * @type {'ACTION_ENABLE_TRAVELLING'}
 * @constant
 */
const ENABLE_TRAVELLING = 'ACTION_ENABLE_TRAVELLING';

/**
 * The 'SHAKE' action.
 * @type {'ACTION_SHAKE'}
 * @constant
 */
const SHAKE = 'ACTION_SHAKE';

export {

    DISABLE_TRAVELLING,
    ENABLE_TRAVELLING,
    SHAKE
};
